import React from "react";
import { withStyles } from "@material-ui/core/styles";
import CardStyle from "../../styles/cardStyle";

class Card extends React.Component {
  render() {
    let {
      classes,
      data = {},
      src,
      handleRouteChange,
      showSelectedStyle,
      selected,
      routePath,
      callStarted,
    } = this.props;
    return (
      <div data-view="card" className={classes.cardContainer}>
        <div
          id="card"
          onClick={(e) => handleRouteChange(e, routePath, data)}
          className={`${classes.card} ${
            showSelectedStyle && selected ? classes.cardSelected : ""
          } ${
            callStarted && !selected
              ? classes.disabledCard
              : callStarted && selected
              ? classes.disabledCardCursor
              : ""
          }`}
        >
          <div className={classes.iconTextWrapper}>
            <div
              id="card-name"
              className={`${classes.name}  ${
                callStarted && !selected ? classes.disabledCardName : ""
              }`}
            >
              {data.FirstName} {data.LastName}
            </div>
            <div id="card-icon" className={classes.iconContainer}>
              <img alt="" className={classes.icons} src={src} />
            </div>
          </div>
          <div id="card-storefront-name" className={classes.company}>
            {data.ProductName} ; {data.StoreFrontName}
          </div>
          <div className={classes.dobWrapper}>
            <div id="card-state" className={classes.state}>
              {data.State}
            </div>
            <div id="card-dob" className={classes.Dob}>
              <span className={classes.dobStyle}>DOB :</span>{" "}
              {data.DOB ? data.DOB : ""}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(CardStyle)(Card);
